import { Collapse, Grid, MenuItem } from "@mui/material";
import React, { useEffect } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { discountTypes } from "../../../variables/app";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormDatetimeTC from "../../../components/Forms/FormDatetimeTC";

function Algemeen() {
  const { vestigingId } = useFormContext();

  const discountTypeOptions = convertArrayToSelectOptions(discountTypes, null);

  const third_party = useWatch({ name: "third_party" });
  const lightspeedKDiscount = useWatch({ name: "custom_data.third_party_settings.lightspeedk.discount" });
  const {
    field: { onChange },
  } = useController({ name: "discountType" });
  const {
    field: { onChange: onChangePercentage },
  } = useController({ name: "priceDiscountPercentage" });
  const {
    field: { onChange: onChangeAmount },
  } = useController({ name: "priceDiscountAmount" });

  useEffect(() => {
    if (lightspeedKDiscount) {
      const object = JSON.parse(lightspeedKDiscount) as {
        name: string;
        code: string;
        discountPercentage?: string;
        discountAmount?: string;
      };
      if (object.discountAmount !== undefined) {
        onChange("AMOUNT_OFF_TOTAL");
        onChangeAmount(Number(object.discountAmount));
      } else if (object.discountPercentage !== undefined) {
        onChange("PERCENTAGE_OFF_TOTAL");
        onChangePercentage(Number(object.discountPercentage));
      }
    }
  }, [lightspeedKDiscount, onChange, onChangeAmount, onChangePercentage]);

  const thirdPartyIsLightspeedK = third_party === "LIGHTSPEEDK";
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <FormTextTC name={"title"} tDefault={"Titel"} tKey={"voucherDefs.form.algemeen.label.title"} />

            <FormSelectTC
              defaultValue={"JAMEZZ"}
              name={"third_party"}
              options={[
                <MenuItem value={"JAMEZZ"}>Jamezz</MenuItem>,
                <MenuItem value={"PIGGY"}>Piggy</MenuItem>,
                <MenuItem value={"LIGHTSPEEDK"}>Lightspeed-K</MenuItem>,
              ]}
              tDefault={"Third party promotion/vouchers"}
              tKey={"Third party promotion/vouchers"}
            />
            <Collapse in={third_party == "PIGGY"} sx={{ width: 1 }} unmountOnExit>
              <FormAsyncTC
                async={{ url: `core/piggy/listPromotions?vid=${vestigingId}` }}
                name={"custom_data.third_party_settings.piggy.promotion_uuid"}
                tDefault={"Piggy promotion"}
                tKey={"custom_data.third_party_settings.piggy.promotion_uuid"}
              />
            </Collapse>
            <Collapse in={third_party == "LIGHTSPEEDK"} sx={{ width: 1 }} unmountOnExit>
              <FormAsyncTC
                async={{ url: `core/pos-api/lightspeed-k/getDiscounts?vid=${vestigingId}` }}
                name={"custom_data.third_party_settings.lightspeedk.discount"}
                tDefault={"LightspeedK Discount"}
                tKey={"custom_data.third_party_settings.lightspeedk.discount"}
              />
            </Collapse>

            <FormSelectTC
              fieldProps={({ value }) => {
                const multiple = false;
                return {
                  disabled: thirdPartyIsLightspeedK,
                  value: value ?? (multiple ? [] : "") ?? "",
                  multiple: multiple,
                };
              }}
              name={"discountType"}
              options={discountTypeOptions}
              tDefault={"Discount Type"}
              tKey={"voucherDefs.form.algemeen.label.discountTypes"}
            />

            <Collapse in={third_party == "Jamezz" || third_party == null} sx={{ width: 1 }} />
            <>
              <FormSwitchTC name={"active"} tDefault={"Active"} tKey={"voucherDefs.form.algemeen.label.is_actief"} />
              <FormSwitchTC name={"blocked"} tDefault={"Blocked"} tKey={"voucherDefs.form.algemeen.label.is_blocked"} />

              <FormDatetimeTC
                name={"dateFrom"}
                tDefault={"Active from date"}
                tKey={"voucherDefs.form.overige.label.dateFrom"}
              />
              <FormDatetimeTC
                name={"dateUntil"}
                tDefault={"Active until date"}
                tKey={"voucherDefs.form.overige.label.dateUntil"}
              />

              <FormControlledInputTC
                name={"maxUsedEver"}
                tDefault={"Max Used Ever (0 = unlimited)"}
                tKey={"voucherDefs.form.algemeen.label.maxUsedEver"}
                type={"number"}
              />

              <FormControlledInputTC
                name={"maxUsedPerDay"}
                tDefault={"Max Used Per Day (0 = unlimited)"}
                tKey={"voucherDefs.form.algemeen.label.maxUsedPerDay"}
                type={"number"}
              />
            </>

            <FormSwitchTC
              name={"allowCombiningSameVoucherTypes"}
              tDefault={"allowCombiningSameVoucherTypes"}
              tKey={"voucherDefs.form.algemeen.label.allowCombiningSameVoucherTypes"}
            />
            <FormSwitchTC
              name={"allowCombiningOtherVoucherTypes"}
              tDefault={"allowCombiningOtherVoucherTypes"}
              tKey={"voucherDefs.form.algemeen.label.allowCombiningOtherVoucherTypes"}
            />
            <FormControlledInputTC
              name={"minBasketPrice"}
              tDefault={"Minimum basket price total (0 = no minimum)"}
              tKey={"voucherDefs.form.algemeen.label.minBasketPrice"}
              type={"number"}
            />
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
